import { render } from "./DynamicComponentProductionComponent.vue.js?vue&type=template&id=680509c1!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentProductionComponent.vue?vue&type=template&id=680509c1"
import script from "./DynamicComponentProductionComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentProductionComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponentProductionComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentProductionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/DynamicComponentProductionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "680509c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('680509c1', __exports__)) {
    api.reload('680509c1', __exports__)
  }
  
  module.hot.accept("./DynamicComponentProductionComponent.vue.js?vue&type=template&id=680509c1!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentProductionComponent.vue?vue&type=template&id=680509c1", () => {
    api.rerender('680509c1', render)
  })

}


export default __exports__